import React from "react";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation();
  return (
    <div className="max-w-10/12 mx-auto p-4">
      <header className="text-center mb-8">
        <h1 className="text-3xl font-bold">{t("privacyPolicy.title")}</h1>
      </header>
      <section className="space-y-8">
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("privacyPolicy.introTitle")}</h2>
          <p className="text-gray-700">
            {t("privacyPolicy.introBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacyPolicy.collectTitle")}
          </h2>
          <p className="text-gray-700">
            {t("privacyPolicy.collectBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacyPolicy.useTitle")}
          </h2>
          <p className="text-gray-700">
            {t("privacyPolicy.useBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacyPolicy.sharingTitle")}
          </h2>
          <p className="text-gray-700">
            {t("privacyPolicy.sharingBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("privacyPolicy.rightsTitle")}</h2>
          <p className="text-gray-700">
            {t("privacyPolicy.rightsBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">
            {t("privacyPolicy.changesTitle")}
          </h2>
          <p className="text-gray-700">
            {t("privacyPolicy.changesBody")}
          </p>
        </div>
        <div className="bg-gray-100 p-6 rounded-lg shadow-lg">
          <h2 className="text-2xl font-semibold mb-4">{t("privacyPolicy.contactTitle")}</h2>
          <p className="text-gray-700">
            {t("privacyPolicy.contactBody")}
          </p>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
